/**
 * About Block — Parallax
 */
(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.about');
    const image1 = document.querySelector('.about__image--1');
    const image2 = document.querySelector('.about__image--2');

    if (!section || !image1 || !image2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;

    const update = () => {
      const rect = section.getBoundingClientRect();
      const winH = window.innerHeight;

      let progress = 1 - (rect.bottom / (winH + rect.height));
      progress = Math.max(0, Math.min(1, progress));

      const offset = (progress - 0.5) * 30;

      image1.style.transform = `translateX(${-offset}px)`;
      image2.style.transform = `translateX(${offset}px)`;

      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  });
})();
